export default {
  // 司机状态
  DRIVER_STATE_DICT: () => {
    return {
      // 1: '未审核',
      2: '未激活',
      3: '正常',
      4: '离职',
      10: '封号',
    }
  },
  DRIVER_TYPE_DICT: () => {
    return {
      1: '自营',
      2: '无车加盟',
      3: '有车加盟',
    }
  },
  // 司机准驾类型
  DRIVER_LICENSE_DICT: () => {
    return {
      A1: 'A1',
      A2: 'A2',
      A3: 'A3',
      B1: 'B1',
      B2: 'B2',
      C1: 'C1',
      C2: 'C2',
      C3: 'C3',
      C4: 'C4',
      D: 'D',
      E: 'E',
      Taxi: 'Taxi',
    }
  },
  // 司机服务类型
  DRIVER_SERVER_TYPE_DICT: () => {
    return {
      1: '网络预约出租车',
      2: '巡游出租车',
      3: '私人小客车合乘',
    }
  },
  // 司机婚姻状况
  MARITAL_STATUS_DICT: () => {
    return {
      10: '未婚',
      20: '已婚',
      40: '离婚',
    }
  },
  // 外语能力
  LANGUAGE_LEVEL_DICT: () => {
    return {
      1: '精通',
      2: '熟练',
      3: '良好',
      4: '一般',
    }
  },
  // 学历
  EDUCATION_DICT: () => {
    return {
      17: '研究生',
      21: '大学本科',
      31: '大学专科',
      41: '中等专科毕业',
      61: '普通高中毕业',
      71: '初中毕业',
      81: '小学毕业',
    }
  },
  businessType: () => {
    return {
      300: '快车',
      301: '专车',
      302: '出租车',
      303: '城际',
    }
  },
  // 民族
  NATION_DICT: () => {
    return {
      1: '汉族',
      2: '蒙古族',
      3: '回族',
      4: '藏族',
      5: '维吾尔族',
      6: '苗族',
      7: '彝族',
      8: '壮族',
      9: '布依族',
      10: '朝鲜族',
      11: '满族',
      12: '侗族',
      13: '瑶族',
      14: '白族',
      15: '土家族',
      16: '哈尼族',
      17: '哈萨克',
      18: '傣族',
      19: '黎族',
      20: '傈傈族',
      21: '佤族',
      22: '畲族',
      23: '高山族',
      24: '拉祜族',
      25: '水族',
      26: '东乡族',
      27: '纳西族',
      28: '景颇族',
      29: '柯尔克孜族',
      30: '土族',
      31: '达翰尔族',
      32: '仫佬族',
      33: '羌族',
      34: '布朗族',
      35: '撒拉族',
      36: '毛难族',
      37: '仡佬族',
      38: '锡伯族',
      39: '阿昌族',
      40: '普米族',
      41: '塔吉克族',
      42: '怒族',
      43: '乌孜别克族',
      44: '俄罗斯族',
      45: '鄂温克族',
      46: '崩龙族',
      47: '保安族',
      48: '裕固族',
      49: '京族',
      50: '塔塔尔族',
      51: '独龙族',
      52: '鄂伦春族',
      53: '赫哲族',
      54: '门巴族',
      55: '珞巴族',
      56: '基诺族',
    }
  },

  DRIVER_OPERATE_DICT: () => {
    return {
      0: '正式',
      1: '非正式',
    }
  },
  DRIVER_PUSH_STATUS: () => {
    return {
      0: '已开启',
      1: '未开启',
    }
  },
  DISPOSE_SOURCE_DICT: () => {
    return {
      10: ' 渠道',
    }
  },
  // 处罚状态dict
  DISPOSE_TYPE_DICT: () => {
    return {
      dispatcher_warning: '警告',
      dispatcher_disable: '调度封禁',
      dispatcher_enable: '调度解禁',
      dispatcher_penalty: '扣违约金',
    }
  },
  // 处罚状态list
  DISPOSE_TYPE_LIST: () => {
    return [
      { value: 'dispatcher_warning', label: '警告' },
      { value: 'dispatcher_disable', label: '调度封禁' },
      { value: 'dispatcher_enable', label: '调度解禁' },
      { value: 'dispatcher_penalty', label: '扣违约金' },
    ]
  },
  // 执行状态
  EXECUTE_STATE_DICT: () => {
    return {
      10: '待执行',
      20: '拒绝执行',
      30: '执行超时',
      40: '已执行',
      50: '待撤销',
      60: '已撤销',
    }
  },
  EXECUTE_STATE_LIST: () => {
    return [
      { value: '10', label: '待执行' },
      { value: '20', label: '拒绝执行' },
      { value: '30', label: '执行超时' },
      { value: '40', label: '已执行' },
      { value: '50', label: '待撤销' },
      { value: '60', label: '已撤销' },
    ]
  },
  // 扣违约金状态 penaltyState
  PENALTY_STATE_DICT: () => {
    return {
      100: '未扣违约金',
      200: '已扣违约金',
      300: '待退款',
      400: '已退款',
    }
  },
  // 扣违约金状态
  PENALTY_STATE_LIST: () => {
    return [
      { value: '100', label: '未扣违约金' },
      { value: '200', label: '已扣违约金' },
      { value: '300', label: '待退款' },
      { value: '400', label: '已退款' },
    ]
  },
  // 处置列表 - 处置状态
  EXE_STATE_LIST: () => {
    return [
      { value: '0', label: '待处置' },
      { value: '1', label: '执行中' },
      { value: '350', label: '已执行' },
      { value: '360', label: '待撤回' },
      { value: '460', label: '已撤回' },
      { value: '2', label: '已结束' },
      { value: '3', label: '关闭' },
      { value: '420', label: '免责卡关闭' },
    ]
  },
  // 司机置信度
  DRIVER_MARK: () => {
    return [
      { value: 1, label: '低' },
      { value: 2, label: '中' },
      { value: 3, label: '高' },
    ]
  },
}

